module.exports = __webpack_public_path__ + "img/NGNL1.e9f403ef.jpg";